import { createSelector } from 'reselect';
import { mapWithDefault } from '../../../utils/dataMapper';

const selectStepRentalVehicle = (state) => state.get('stepRentalVehicle');

const makeSelectStepRentalVehicle = () =>
  createSelector(selectStepRentalVehicle, (stepRentalVehicleState) => ({
    areYouClaimingForRentalVehicleExcess: mapWithDefault(
      stepRentalVehicleState,
      () => stepRentalVehicleState.getIn(['form', 'areYouClaimingForRentalVehicleExcess']),
      ''
    ),
    nameOfThePersonDrivingTheCar: mapWithDefault(
      stepRentalVehicleState,
      () => stepRentalVehicleState.getIn(['form', 'nameOfThePersonDrivingTheCar']),
      ''
    ),
    driverDateOfBirth: mapWithDefault(
      stepRentalVehicleState,
      () => stepRentalVehicleState.getIn(['form', 'driverDateOfBirth']),
      ''
    ),
    dateOfExpense: mapWithDefault(
      stepRentalVehicleState,
      () => stepRentalVehicleState.getIn(['form', 'dateOfExpense']),
      ''
    ),
    description: mapWithDefault(
      stepRentalVehicleState,
      () => stepRentalVehicleState.getIn(['form', 'description']),
      ''
    ),
    rentalVehicleExcessAmount: mapWithDefault(
      stepRentalVehicleState,
      () => stepRentalVehicleState.getIn(['form', 'rentalVehicleExcessAmount']),
      ''
    ),
    rentalVehicleExcessAmountCurrency: mapWithDefault(
      stepRentalVehicleState,
      () => stepRentalVehicleState.getIn(['form', 'rentalVehicleExcessAmountCurrency']),
      ''
    ),
    actualRepairAmount: mapWithDefault(
      stepRentalVehicleState,
      () => stepRentalVehicleState.getIn(['form', 'actualRepairAmount']),
      ''
    ),
    actualRepairAmountCurrency: mapWithDefault(
      stepRentalVehicleState,
      () => stepRentalVehicleState.getIn(['form', 'actualRepairAmountCurrency']),
      ''
    ),
    amountClaimed: mapWithDefault(
      stepRentalVehicleState,
      () => stepRentalVehicleState.getIn(['form', 'amountClaimed']),
      ''
    ),
    amountClaimedCurrency: mapWithDefault(
      stepRentalVehicleState,
      () => stepRentalVehicleState.getIn(['form', 'amountClaimedCurrency']),
      ''
    ),
  }));

const makeSelectStepRentalVehicleErrors = () =>
  createSelector(selectStepRentalVehicle, (state) => state.get('errors'));

export { makeSelectStepRentalVehicle, makeSelectStepRentalVehicleErrors };



// WEBPACK FOOTER //
// ./app/containers/FastCover/StepRentalVehicle/selectors.js